module.exports = __webpack_public_path__ + "img/loginbg.80fb5715.jpg";